import { writable } from 'svelte/store';

export const tool = writable({
  id: 0,
  name: '',
  description: '',
  tags: [],
  specifications: [
    {
      id: '',
      description: '',
      image: null,
      tags: '',
      deleted: false,
    },
  ],
  specification_images: [], // uploaded images stored separately
});

export const tools = writable({});

export const specification = writable({
  description: '',
});

export const toolDetail = writable({});
export const relatedActivities = writable({});
